<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Editar Motivo</h5>
        </div>        
        <emt-form ref="reason-form" v-bind:resource="config.api + '/reason/'" v-bind:items="itemsForm" v-bind:updateData="update"></emt-form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'

export default{
    name: 'emt-form-edit-reason',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Motivo',
                    'placeholder': 'Ingrese motivo',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'area',
                    'label': 'Área',
                    'placeholder': 'Seleccione una área',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }
            ],
            config: Config,
            update: true
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getArea()
    },
    methods: {
        getData: function (url) {
            url = url + this.$route.params.id + '/'
            let self = this
            self.$http.get(url).then(function (response) {
                self.setValue(response.body)
            }, function (response) {
            })
        },
        setValue: function (value) {
            let self = this
            for (var form in this.itemsForm) {
                if (this.itemsForm[form].name === 'area') {
                    var activeOptions = self.itemsForm[form].select_options
                    var flag = false
                    for (var i = 0; i < activeOptions.length; i++) {
                        if (activeOptions[i].value === value[self.itemsForm[form].name]) {
                            self.itemsForm[form].value = value[self.itemsForm[form].name]
                            flag = true
                        }
                    }
                    if (!flag) {
                        self.itemsForm[form].value = ''
                    }
                } else {
                    this.itemsForm[form].value = value[this.itemsForm[form].name]
                }
            }
        },
        /*
        *esta funcion permite consultar y listar los motivos
        */
        getArea: function () {
            var self = this
            self.$http.get(Config.api + '/area/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
                this.getData(Config.api + '/reason/')
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    components: {
        'emt-form': EmtForm
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-edit-reason.vue?0be9a4c8